export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Diagnóstico Inicial',
      description: 'Análise completa da situação atual do seu negócio, identificando gargalos, oportunidades e prioridades de melhoria.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Mapeamento de Processos',
      description: 'Documentação detalhada de todos os processos operacionais, fluxos de trabalho e pontos críticos da operação.',
      icon: 'ri-map-pin-line'
    },
    {
      number: '03',
      title: 'Plano de Ação',
      description: 'Criação de roadmap personalizado com priorização de melhorias, cronograma e metas claras para os próximos meses.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '04',
      title: 'Implementação Guiada',
      description: 'Execução das melhorias com acompanhamento mensal, ajustes contínuos e suporte especializado durante todo o programa.',
      icon: 'ri-settings-3-line'
    },
    {
      number: '05',
      title: 'Monitoramento e Ajustes',
      description: 'Acompanhamento de indicadores, análise de resultados e refinamento constante para garantir máxima eficiência.',
      icon: 'ri-dashboard-line'
    },
    {
      number: '06',
      title: 'Consolidação',
      description: 'Estabilização dos processos otimizados, capacitação da equipe e preparação para crescimento sustentável.',
      icon: 'ri-trophy-line'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-primary-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Como funciona o programa?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Metodologia estruturada em 6 etapas para transformar seu negócio 
            em 10-12 meses com resultados mensuráveis
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 relative group cursor-pointer"
            >
              {/* Number Badge */}
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-coral-500 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                <span className="text-white font-bold text-lg">{step.number}</span>
              </div>

              <div className="w-14 h-14 bg-coral-500/10 rounded-xl flex items-center justify-center mb-6">
                <i className={`${step.icon} text-2xl text-coral-500`}></i>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Timeline Connector for Desktop */}
        <div className="hidden lg:block mt-12">
          <div className="flex items-center justify-center gap-4">
            <div className="flex-1 h-1 bg-coral-500/30"></div>
            <div className="px-6 py-3 bg-coral-500 text-white rounded-full font-semibold whitespace-nowrap">
              10-12 meses de transformação
            </div>
            <div className="flex-1 h-1 bg-coral-500/30"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
